jQuery( function($){

    var $body = $('body');
    $body.on('click', '[data-p-modal]', function(e){
        var targe_selector = $(this).data('p-modal');
        var $target = $(targe_selector);
        openModal( $target );
        e.preventDefault();
    });

    function openModal($modal_content) {
        if(!$modal_content.data('p-modal-setup')){
            setupModal($modal_content);
        }
        $modal_content.data('overlay').fadeIn();
        $body.addClass('p-modal-is-open');
    }

    function setupModal( $target ){
        var $overlay = $('<div class="p-modal__overlay"></div>');
        var $container = $('<div class="p-modal__container"></div>');
        var $close = $('<div class="p-modal__close"></div>');

        $body.append($overlay);
        $overlay.append($container);
        $container.append($target);
        $target.append($close).show();

        function closeThisModal(){
            $overlay.fadeOut();
            $body.removeClass('p-modal-is-open');
        }

        $close.on('click', closeThisModal );
        $overlay.on('click', closeThisModal );
        $target.on('click', stopPropagation );

        $target.data('overlay', $overlay);

    }

    function stopPropagation(e){
        e.stopPropagation();
    }

});